import { useEffect, useState } from "react";
import { ToastWrapper, ToastItem } from "./StyleToogleNotification";

interface ToastMessage {
  id: string;
  message: string;
  type?: "success" | "error" | "info";
}

const ToastContainer = () => {
  const [toasts, setToasts] = useState<ToastMessage[]>([]);

  useEffect(() => {
    const handler = (e: CustomEvent) => {
      const toast: ToastMessage = {
        id: crypto.randomUUID(),
        message: e.detail.message,
        type: e.detail.type,
      };

      setToasts((prev) => [...prev, toast]);

      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== toast.id));
      }, 3000);
    };

    window.addEventListener("app-toast", handler as EventListener);
    return () =>
      window.removeEventListener("app-toast", handler as EventListener);
  }, []);

  return (
    <ToastWrapper>
      {toasts.map((t) => (
        <ToastItem key={t.id} type={t.type}>
          {t.message}
        </ToastItem>
      ))}
    </ToastWrapper>
  );
};

export default ToastContainer;
